// extracted by mini-css-extract-plugin
module.exports = {"title":"subscribe-module--title--TOvEi","newsletter":"subscribe-module--newsletter--3GxO4","desc":"subscribe-module--desc--TfNN4"};